export const sliderProductsConfig = {
  dots: true,
  infinite: true,
  slidesToShow: 7,
  slidesToScroll: 7,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 2000,
  pauseOnFocus: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 5,
        infinite: true,
      },
    },
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 850,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

export const sliderCategoriesResponsiveConfig = [
  {
    breakpoint: 1350,
    settings: {
      slidesToShow: 7,
      slidesToScroll: 7,
      infinite: true,
    },
  },
  {
    breakpoint: 1150,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6,
    },
  },
  {
    breakpoint: 1000,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  },
  {
    breakpoint: 850,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 2,
    },
  },
  {
    breakpoint: 500,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
  },
]

const classNameActive = 'void-plp__suggested-category__item--active'
export const iscategoryActive = category => (decodeURIComponent(window.location.pathname).includes(decodeURIComponent(category.link)) ? classNameActive : '')
